import { RegularHoursDto } from 'gleblu-socket-api';

import { RegularHour } from '../interfaces/Hours';

export function toDto(regularHours: RegularHour[], placeUuid: string): RegularHoursDto {
  return {
    placeUuid,
    regularHours,
  };
}
